export default function LecturasPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">📖 Lecturas de Torah</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">
          Módulo de lecturas semanales de Torah en desarrollo.
        </p>
      </div>
    </div>
  );
}






